export default class AdminAPI {
  private services: any;

  constructor(services) {
    this.services = services;
    services.afterLoad(() => {
      // after load
    });
  }

  public getUserAssessments() {
    return this.services.baseAPI
      .get(`/admin/assessments/user_assessments/`, false);
  }

  public getCurrentCourseLessons({ courseID }) {
    return this.services.baseAPI
      .get(`admin/course_lessons/by_course/?id=${courseID}`, false);
  }
 
  public getAllProfiles(page, size, searchString) {

    console.log('searchString', searchString);

    const sr = searchString===undefined ? '' : searchString;

    const query = sr.length ? `&search=${sr}` : '';

    return this.services.baseAPI
      .get(`admins/user_profiles/all?page=${page}&page_size=${size}${query}`, false);
  }

  public getAllSubscriptions(page, size, searchString) {
      
      console.log('searchString', searchString);
  
      const sr = searchString===undefined ? '' : searchString;
  
      const query = sr.length ? `&search=${sr}` : '';
  
      return this.services.baseAPI
        .get(`admins/subscriptions/all?page=${page}&page_size=${size}${query}`, false);
  }

  public getCollectionItems(collectionID) {
    return this.services.baseAPI
      .get(`admin/asset_collections/${collectionID}/assets/`, false);
  }

  public getCollectionVideoItems(collectionID) {
    return this.services.baseAPI
      .get(`admin/asset_collections/${collectionID}/video_assets/`, false);
  }

  public getCollectionVimeoItems(collectionID) {
    return this.services.baseAPI
      .get(`admin/asset_collections/${collectionID}/vimeo_assets/`, false);
  }

  public getUserProfiles(userTypeID) {
    return this.services.baseAPI
      .get(`admin/userprofiles/items_overview/?id=${userTypeID}`, false);
  }

  public getSchoolStudents(orgID) {
    return this.services.baseAPI
      .get(`admin/organisations/${orgID}/student_members/`, false);
  }

  public getSchoolMembers(orgID) {
    return this.services.baseAPI
      .get(`admin/organisations/${orgID}/all_members/`, false);
  }

  public getSchools() {
    return this.services.baseAPI
      .get(`admin/organisations/overview_items/`, false);
  }

  public getVimeoVideos(searchKey) {
    const query = searchKey.length ? `?query=${searchKey}` : '';
    return this.services.baseAPI
      .get(`admin/vimeo_videos/overview_items/${query}`, false);
  }

  public getReports() {
    return this.services.baseAPI
      .get(`admin/reports/overview_items/`, false);
  }

  public genReports(userID) {
    return this.services.baseAPI
      .get(`admin/userprofiles/refresh_reports/?id=${userID}`, false);
  }

  public genAllReports() {
    return this.services.baseAPI
      .get(`admin/userprofiles/refresh_reports_all/`, false);
  }

  public getLessons() {
    return this.services.baseAPI
      .get(`admin/lessons/overview_items/`, false);
  }

  public getCourses() {
    return this.services.baseAPI
      .get(`admin/courses/overview_items/`, false);
  }

  public getTemplates() {
    return this.services.baseAPI
      .get(`admin/data_templates/overview_items/`, false);
  }

  public getLessonScreens(lessonID, editmode) {
    if (!editmode) {
      return this.services.baseAPI
      .get(`admin/lesson_screens/by_lesson/?id=${lessonID}`, true);
    }
    else {
      return this.services.baseAPI
      .get(`admin/lesson_screens/by_lesson_edit/?id=${lessonID}`, false);
    }
    
  }

  public getLessonScreensInteractions(lessonID) {

    return this.services.baseAPI
      .get(`admin/lesson_screens/by_lesson_interactions/?id=${lessonID}`, false);
    
  }

  public getLessonScreensInteractionsAnonymous(lessonID, difficulty) {

    return this.services.baseAPI
      .get(`admin/lesson_screens/by_lesson_interactions_anonymous/?id=${lessonID}&difficulty=${difficulty}`, true);
    
  }

  public getInteractionFromUrl(interactionUrl) {

    return this.services.baseAPI
      .get(`${interactionUrl}`, true);
    
  }

  public getAllLessons() {
    return this.services.baseAPI
      .get(`admin/lessons/overview_items/`, false);
  }

  public getSessionInfo() {
    return this.services.baseAPI
      .get(`admin/assessment_sessions/overview_items/`, false);
  }

  public getUserSummary() {
    return this.services.baseAPI
      .get(`admin/userprofiles/users_overview/`, false);
  }

  public getAssessmentSummary() {
    return this.services.baseAPI
      .get(`admin/assessments/general_overview/`, false);
  }

  public getAutorecommenderConfigs() {
    return this.services.baseAPI
      .get(`admin/autorecommender/overview_items/`, false);
  }
  
  public getCurrentUserRelatedAssessmentResults({ assessmentGroupID }) {
    return this.services.baseAPI
      .get(`/admin/assessments/base_comparison_filter/?groupid=${assessmentGroupID}`, false);
  }

  public getAssessmentQuestionGroups({ assessmentID }) {
    return this.services.baseAPI
      .get(`/admin/assessments/${assessmentID}/assessment_question_groups/`, false);
  }

  public getInteractionSets() {
    return this.services.baseAPI
      .get(`/admin/interaction_sets/`, false);
  }

  public getInteractionSetsOverview() {
    return this.services.baseAPI
      .get(`/admin/interaction_sets/list_items/`, false);
  }

  public getVideoAssets() {
    return this.services.baseAPI
      .get(`/admin/assets/video_items/`, false);
  }

  public getAssetCollections() {
    return this.services.baseAPI
      .get(`/admin/asset_collections/`, false);
  }

  public getSystemVariables() {
    return this.services.baseAPI
      .get(`/admin/system_variables/`, false);
  }

  public getAssetCollectionsOverview() {
    return this.services.baseAPI
      .get(`/admin/asset_collections/overview_items/`, false);
  }

  public getIconsOverview() {
    return this.services.baseAPI
      .get(`/admin/icons/overview_items/`, false);
  }

  public getAssessments() {
    return this.services.baseAPI
      .get(`/admin/assessments/overview_items/`, false);
  }

  public getUserAssessmentResults({ assessmentGroupID, userID }) {
    return this.services.baseAPI
      .get(`/admin/assessments/user_assessment_results/?userid=${userID}&groupid=${assessmentGroupID}`, false);
  }

  public manualLearnerCourseAllocate( userID, courseID ) {
    return this.services.baseAPI
      .get(`/admins/allocations/${userID}/courses/${courseID}/create_allocation_activate`, false);
  }

  public getAssessmentQuestionsPlusAnswers(assessmentID) {
    return this.services.baseAPI
      .get(`/admin/assessment_questions/by_assessment_plus_answers/?id=${assessmentID}`, false);
  }

  public getSingleItemGeneral(itemName, itemId) {
    return this.services.baseAPI
      .get(`/admin/${itemName}/${itemId}/`, false);
  }

  public getItemCountGeneral(itemName) {
    return this.services.baseAPI
      .get(`/admin/${itemName}/item_count/`, false);
  }

  public getSingleInteraction(itemId) {
    return this.services.baseAPI
      .get(`/interactions/${itemId}/`, false);
  }

  public verifyInstitutionScores(itemId) {
    return this.services.baseAPI
      .get(`admins/institutions/${itemId}/verify_scores`, false);
  }

  public rebuildInstitutionScores(itemId, assessmentId, sid) {
    return this.services.baseAPI
      .get(`admins/automations/institutions/${itemId}/assessments/${assessmentId}/rebuild_scores?sid=${sid}`, false);
  }

  public verifyAllInstitutionScores(itemId) {
    return this.services.baseAPI
      .get(`admins/institutions/verify_all_scores`, false);
  }

  public getOrganisationAssessments(orgId) {
    return this.services.baseAPI
      .get(`admins/institutions/${orgId}/assessments_list`, false);
  }

  public institutionCompletionReport(orgId, endDate) {
    return this.services.baseAPI
      .get(`admins/institutions/${orgId}/assessments/end/${endDate}/completion_report`, false);
  }

  public institutionExecutiveReport(orgId) {
    return this.services.baseAPI
      .get(`admins/institutions/${orgId}/executive_report`, false);
  }

  public getInteractions() {
    return this.services.baseAPI
      .get(`/interactions/`, false);
  }

  public getSetInteractions(itemId) {
    return this.services.baseAPI
      .get(`/interactions/by_set/?id=${itemId}`, false);
  }

  public getSystemMessages() {
    return this.services.baseAPI
      .get(`/admin/system_emails/user_emails/`, false);
  }

  public getUserLevels() {
    return this.services.baseAPI
      .get(`/admin/user_levels/`, false);
  }

  public getSFConfigs() {
    return this.services.baseAPI
      .get(`/admin/sfconfigs/overview_items/`, false);
  }

  public getTargetGroups() {
    return this.services.baseAPI
      .get(`/admin/target_groups/`, false);
  } 

  public createItemGeneral(itemName, itemData) {
    return this.services.baseAPI
      .post(`admin/${itemName}/`, itemData, false);
  }

  public updateItemGeneral(itemName, itemData, itemId) {
    return this.services.baseAPI
      .put(`admin/${itemName}/${itemId}/`, itemData, false);
  }

  public updateInteractionInfo(itemData, itemId) {
    return this.services.baseAPI
      .put(`interactions/${itemId}/change_general/`, itemData, false);
  }

  public updateAssetPartial(itemData, itemId) {
    return this.services.baseAPI
      .put(`admin/assets/${itemId}/change_general/`, itemData, false);
  }

  public updateScreenPartial(itemData, itemId) {
    return this.services.baseAPI
      .put(`admin/lesson_screens/${itemId}/change_general/`, itemData, false);
  }

  public updateInteractionBuilder(itemData, interactionType, itemId) {
    return this.services.baseAPI
      .put(`interactions/interaction-builder/${interactionType}/${itemId}/`, itemData, false);
  }

  public createInteractionBuilder(itemData, interactionType) {
    return this.services.baseAPI
      .post(`interactions/interaction-builder/${interactionType}/`, itemData, false);
  }
 
  public deleteItemGeneral(itemName, itemId) {
    return this.services.baseAPI
      .delete(`admin/${itemName}/${itemId}/`, false);
  }

  public deleteInteraction(itemId) {
    return this.services.baseAPI
      .delete(`interactions/${itemId}/`, false);
  }

  public updateLessonScreenOrder(itemData) {
    return this.services.baseAPI
      .post(`admin/lesson_screens/update_order/`, itemData, false);
  }

  public updateCourseLessonOrder(itemData) {
    return this.services.baseAPI
      .post(`admin/course_lessons/update_order/`, itemData, false);
  }

  public updloadUrn(itemData, orgID) {
    return this.services.baseAPI
      .post(`admin/organisations/${orgID}/upload_student_urns/`, itemData, false);
  }

  public uploadEmails(itemData) {
    return this.services.baseAPI
      .post(`/admin/system_emails/bulk_email_send/`, itemData, false);
  }

  public updloadDept(itemData, orgID) {
    return this.services.baseAPI
      .post(`admin/organisations/${orgID}/upload_student_data/`, itemData, false);
  }

  public updloadInteractionZip(itemData) {
    return this.services.baseAPI
      .post(`admin/interaction_sets/zip_upload_v1/`, itemData, false);
  }

  public saveVimeo(itemData) {
    return this.services.baseAPI
      .post(`admin/assets/vimeo_add/`, itemData, false);
  }

  public createSFData(itemData) {
    return this.services.baseAPI
      .post(`admins/sf/data/create`, itemData, false);
  }

  public updloadLessonPdf(itemData, lessonID) {
    return this.services.baseAPI
      .post(`admin/lessons/${lessonID}/upload_pdf/`, itemData, false);
  }

  public updloadLessonImages(itemData, lessonID) {
    return this.services.baseAPI
      .post(`admin/lessons/${lessonID}/upload_images/`, itemData, false);
  }

  public updloadAsset(itemData) {
    return this.services.baseAPI
      .post(`admin/assets/multiupload/`, itemData, false);
  }

  public updloadTemplate(itemData) {
    return this.services.baseAPI
      .post(`admin/data_templates/upload/`, itemData, false);
  }

  public updloadAutoRecommenderConfig(itemData) {
    return this.services.baseAPI
      .post(`admin/autorecommender/csv_upload/`, itemData, false);
  }

  // onboarding
  public getOnboardingItems() {
    return this.services.baseAPI
      .get(`admin/lessons/onboarding_items/`, true);
  }

  public getNextAssessment() {
    return this.services.plBaseAPI.get(`assessments/next-assessment`);
  }
 
  public getNextAssessmentContent(id) {
    return this.services.plBaseAPI.get(`assessments/view-assessment/${id}`, false);
  }

 
  public submitAssessmentResponses(item) {
    return this.services.baseAPI.post(`users/assessments/submit_responses`, item,  false);
  }

  public submitAssessmentResponsesBinary(item, sid) {
    return this.services.baseAPI.post(`users/assessments_upload_async/submit_responses_binary_async?sid=${sid}`, item,  false); 
  }

  public submitAssessmentResponsesTextAsyn(item) {
    return this.services.plBaseAPI.post(`assessments/submit-assessment`, item,  false); 
  }


  public requestLearnerWorspaceOperation(item) {
    return this.services.plBaseAPI.post(`admins/learner-workspace-operation`, item,  false); 
  }

  public submitUpgradedAssessmentResponsesBinary(item, sid) {
    return this.services.baseAPI.post(`users/upgraded_assessments_upload/submit_responses_binary?sid=${sid}`, item,  false); 
  }

  public getPackagesList() {
    return this.services.baseAPI.get(`users/packages/filtered_list`, false);
  }

  public getSingleProfile(id) {
    return this.services.baseAPI.get(`admins/user_profiles/${id}/`, false);
  }

  public getSingleSubscription(id) {
    return this.services.baseAPI.get(`admins/subscriptions/${id}/`, false);
  }

  public updateSingleProfile(id, itemData) {

    return this.services.baseAPI.post(`admins/user_profiles/${id}/update`, itemData, false);
  }

  public updateSingleSubscription(id, itemData) {

    return this.services.baseAPI.post(`admins/subscriptions/${id}/update`, itemData, false);
  }

  // burton viz
  public getPerceptions() {
    return this.services.baseAPI.get(`assessments/perceptions/`);
  }
  public getAssessmentsPerceptions(userID) {
    return this.services.baseAPI.get(`users/${userID}/perceptions`);
  }

  public getUserAssessmentsList(userID) {
    return this.services.baseAPI.get(`users/${userID}/assessments/list`);
  }

  public initAutogenCourses() {
    return this.services.baseAPI.get(`admins/autorecommender/coursedata/create`);
  }

  public getUserResponsesComparison(userID, assessmentID1, assessmentID2) {
    return this.services.baseAPI.get(`users/${userID}/assessments/${assessmentID1}/${assessmentID2}/compare_responses`);
  }

  public fetchVimeoSystemVar(varName) {
    return this.services.baseAPI.get(`system/vars/${varName}/`);
  }

  public updatePassword(item) {
    return this.services.baseAPI.put(`users/update_password`, item);
  }

  public updateUserProfileInfo(item) {
    return this.services.baseAPI.put(`users/profiles/update`, item);
  }

  public requestPasswordResetToken(email) {
    return this.services.baseAPI.post(`users/password_reset/request_token/`, email, true);
  }

  public validatePasswordResetToken(token) {
    return this.services.baseAPI.post(`users/password_reset/validate_token/`, token, true);
  }

  public confirmPasswordReset(item) {
    return this.services.baseAPI.post(`users/password_reset/confirm/`, item, true);
  }

  public fetchUserInfo() {
    return this.services.baseAPI.get(`users/info`);
  }
  public checkCoupon(item, pkID) {
    return this.services.baseAPI.get(`coupons/${item}/${pkID}`);
  }
  public getUserNoGroupResults(userID, assessmentID) {
    return this.services.baseAPI.get(`users/${userID}/assessments/${assessmentID}/all_responses`);
  }

  public captureUserInterest(item) {
    return this.services.baseAPI.post(`users/interest/declare_interes`, item);
  }

  public updateAvatar(item) {
    return this.services.baseAPI.post(`users/profiles/change_avatar`, item);
  }

  public getAllGenericResponses(userID, assessmentID) {
    return this.services.baseAPI.get(`users/${userID}/assessment_results/${assessmentID}/all_responses_generic_multiuser`);
  }

  public getUserGenericPerceptionsList(userID) {
    return this.services.baseAPI.get(`users/${userID}/perception-generic-assessments`)
  }

  public manualTriggerInstitutionAssessment(institutionID, assessmentID, sid) {
    return this.services.baseAPI.get(`admins/institutions/${institutionID}/assessments/${assessmentID}/manual_allocate?sid=${sid}`); 
  }

  public duplicateLesson(id, sid) {
    return this.services.baseAPI.post(`admin/lessons/${id}/clone_lesson/?sid=${sid}`, null)
  }

  public uploadLessonDownloadableFile(formData) {
    return this.services.baseAPI.post(`/admin/lessonpdfs/multiupload/`, formData)
  }

  public getLessonDownloadableFile(lessonId) {
    return this.services.plBaseAPI.get(`/content/lessons/${lessonId}/pdfs/list`);
  }

  public getNextLessonCompletionDate() {
    return this.services.plBaseAPI.get(`/content/lessons/user_last_completed`);
  }
}



// WEBPACK FOOTER //
// ./src/services/API/v1/Admin.ts